import { getCookie, removeCookie, setCookie } from '../utils/cookie';

const COOKIE = 'cookies-accepted';
const UI_BASE = 'uiBase';

export function cookiesAccepted() {
  return !!getCookie(COOKIE);
}

export function acceptCookies() {
  setCookie(COOKIE, true, 365);
}

export function getUiBaseCookie() {
  return getCookie(UI_BASE);
}

export function setUiBaseCookie(val) {
  setCookie(UI_BASE, val, 30);
}

export function clearUiBaseCookie() {
  removeCookie(UI_BASE);
}



// WEBPACK FOOTER //
// ./src/app/api/cookies.js